import { render, staticRenderFns } from "./ExpirationPeriod.vue?vue&type=template&id=612840b6&scoped=true&"
import script from "./ExpirationPeriod.vue?vue&type=script&lang=js&"
export * from "./ExpirationPeriod.vue?vue&type=script&lang=js&"
import style0 from "./ExpirationPeriod.vue?vue&type=style&index=0&id=612840b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612840b6",
  null
  
)

export default component.exports